import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/admin/Layout';
import ContextStates from '../../context/ContextStates';
import { AiOutlinePlus, AiOutlineSearch } from 'react-icons/ai'
import ListadoClientes from '../../components/admin/listadoClientes';
import { RiFileExcel2Line } from 'react-icons/ri'

const Clientes = () => {

    const { setViewOpen, setFormView, roles, idUsuario, setIdUsuario, buscarCliente, setBuscarCliente } = useContext(ContextStates);
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('pvp_id'))
            setIdUsuario(localStorage.getItem('pvp_id'));
    }, [])

    useEffect(() => {
        if (!roles.includes("1")) {
            navigate("/", { replace: true });
        }
    }, [idUsuario])

    const Alta = () => {
        setFormView(30);
        setViewOpen(true);
    }

    return (
        <Layout
            pagina="Clientes"
        >
            <div className="w-full">
                <h1 className="mt-10 mb-5 text-gray-600 text-3xl text-center">Clientes</h1>
                <div className='w-full h-screen mt-2 bg-white'>
                    <div className='w-full h-16 py-2 px-10 bg-slate-50 flex'>
                        <button
                            className='bg-indigo-600 hover:bg-indigo-400 p-3 rounded-md text-white uppercase flex'
                            onClick={() => Alta(true)}
                        >
                            <AiOutlinePlus className='text-2xl mr-2' />
                            Agregar Cliente
                        </button>
                        <div className='py-3 rounded-3xl bg-white w-1/3 border border-gray-300 mx-auto px-3 flex'>
                            <input
                                type="text"
                                className='w-11/12 outline-none'
                                value={buscarCliente}
                                placeholder="Buscar Cliente"
                                onChange={(e) => setBuscarCliente(e.target.value)}
                            />
                            <AiOutlineSearch className='ml-auto text-2xl' />
                        </div>
                    </div>
                    <div className='w-full h-full p-10 bg-white'>
                        <ListadoClientes />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Clientes